
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';

// project imports
import Drawer from './Drawer';
import Header from './Header';
import Footer from './Footer';
import Loader from 'components/Loader';
import Breadcrumbs from 'components/@extended/Breadcrumbs';
import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';


// ==============================|| MAIN LAYOUT ||============================== //

const DashboardLayout: React.FC = () => {
  const { menuMasterLoading } = useGetMenuMaster();

  const downXL = useMediaQuery((theme: any) => theme.breakpoints.down('xl'));
  const location = useLocation();
  const isInspectorRoute = location.pathname.includes('/inspector/');
  const isTicketsRoute = location.pathname.startsWith('/tickets');

  // set media-wise responsive drawer
  useEffect(() => {
    handlerDrawerOpen(!downXL);
  }, [downXL]);


  if (menuMasterLoading) return <Loader />;

  return (
    <Box sx={{ display: 'flex', width: '100%', ...(isTicketsRoute ? { height: '100vh', overflow: 'hidden' } : {}) }}>
      <Header />
      <Drawer />

      <Box
        component="main"
        sx={{
          width: isInspectorRoute ? '100%' : 'calc(100% - 260px)',
          flexGrow: 1,
          p: isInspectorRoute || isTicketsRoute ? 0 : { xs: 2, sm: 3 },
          ...(isTicketsRoute ? { height: '100vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' } : {})
        }}
      >
        {!isInspectorRoute && <Toolbar sx={{ mt: 'inherit', flexShrink: 0 }} />}
        <Box
          sx={{
            px: isInspectorRoute || isTicketsRoute ? 0 : { xs: 0, sm: 2 },
            position: 'relative',
            minHeight: isInspectorRoute ? '100vh' : isTicketsRoute ? 0 : 'calc(100vh - 110px)',
            ...(isTicketsRoute ? { flex: 1, minHeight: 0, overflow: 'hidden', position: 'relative' } : {}),
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          {!isInspectorRoute && (
            <Breadcrumbs
              heading={undefined}
              icon={undefined}
              icons={undefined}
              links={undefined}
              maxItems={undefined}
              rightAlign={undefined}
              separator={undefined}
              sx={undefined}
            />
          )}
          <Outlet />
          {/* <Footer /> */}
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout;
